<div>
  <app-kf-configuration-filter
    (search)="searchKfConfiguration($event)">
  </app-kf-configuration-filter>
  <mat-divider></mat-divider>
  <app-kf-configuration-table *ngIf="kfConfigurationPage"
                              [page]="kfConfigurationPage.number"
                              [pageSize]="kfConfigurationPage.size"
                              [totalElements]="kfConfigurationPage.totalElements"
                              [kfConfigurations]="kfConfigurationPage.content"
                              [schemaKind]="schemaKind"
                              (loadKfConfigurations)="loadKfConfigurations($event)"
                              (printKfConfiguration)="printPdf($event)">
  </app-kf-configuration-table>
</div>
